import { enqueueSnackbar } from "notistack";

export const SuccessMessage = (message: string) => {
  if (message !== "") {
    return (
      <>{enqueueSnackbar({ variant: "success", message: `${message}` })}</>
    );
  }
};

export const ErrorMessage = (message: string) => {
  if (message !== "") {
    return <>{enqueueSnackbar({ variant: "error", message: `${message}` })}</>;
  }
};

export const WarningMessage = (message: string) => {
  if (message !== "") {
    return (
      <>{enqueueSnackbar({ variant: "warning", message: `${message}` })}</>
    );
  }
};

export const InfoMessage = (message: string) => {
  if (message !== "") {
    return <>{enqueueSnackbar({ variant: "info", message: `${message}` })}</>;
  }
};
